import { render, staticRenderFns } from "./son4.vue?vue&type=template&id=7be5294a&scoped=true"
import script from "./son4.vue?vue&type=script&lang=js"
export * from "./son4.vue?vue&type=script&lang=js"
import style0 from "./son4.vue?vue&type=style&index=0&id=7be5294a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be5294a",
  null
  
)

export default component.exports